import React, { Component } from 'react'
import {Container, Button, Form, FormGroup, Label, Input, Col, Alert} from 'reactstrap'
import {bindActionCreators} from 'redux'
import {Image} from 'react-bootstrap'
import {connect} from 'react-redux'
import * as sessionActions from '../actions/sessionActions'
import * as dataActions from '../actions/dataActions'

import logo from '../images/brand.png'

class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      login: {
        email: '',
        password: ''
      },
      errMsg: null
    }
    this.handleChange = this.handleChange.bind(this)
    this.onSave = this.onSave.bind(this)
  }

  handleErrorMessage (errorMsg) {
    if(errorMsg !== undefined && errorMsg !== null){
      if(errorMsg.includes('password')){
        return 'Mot de passe incorect.'
      } else if (errorMsg.includes('permission')){
        return 'Vous n\'êtes pas authorisé à accéder à ce portail.'
      } else if (errorMsg.includes('email')){
        return 'Adresse email incorrecte.'
      }
    } else {
      return ''
    }
  }

  componentWillReceiveProps(){
    if (this.props.session.active === false && this.props.session.code !== 200) {
      let msg = this.handleErrorMessage(this.props.session.message)
      this.setState({
        toggleMessage: true,
        errMsg: msg
      })
    }
  }

  handleChange (e) {
    this.setState({
      login: {
        ...this.state.login,
        [e.target.name]: e.target.value
      }
    })
  }

  onSave (event) {
    event.preventDefault()
    this.props.userActions.logInUser(this.state.login).then(() => {
      this.props.dataActions.fetchCategories()
      this.props.history.push('/')
    }).catch((error) => {

    })
  }

  render () {
    return (
      <div>
        <Container className={''}>
          <Col md={{size: 4, offset: 4}}>
            <div className={'mT-30 txtcenter'}>
              <Image src={logo} responsive className={'w80p'} />
            </div>
            <h3 className={'txtcenter'}>Connectez vous à votre compte administrateur</h3>
            <Form>
              <FormGroup>
                <Label for='exampleEmail'>Email</Label>
                <Input type='email' name='email' id='exampleEmail' placeholder='Entrez votre email' onChange={this.handleChange.bind(this)} />
              </FormGroup>

              <FormGroup>
                <Label for='examplePassword'>Password</Label>
                <Input type='password' name='password' id='examplePassword' placeholder='Entrez votre mot de passe' onChange={this.handleChange.bind(this)} />
              </FormGroup>
            </Form>
            <Button className={'w100p'} color='success' onClick={this.onSave.bind(this)} >Se Connecter</Button>
            {this.state.toggleMessage === true ? <Alert className={'txtcenter mT-5'} color="danger"><i className="exclamation circle icon"></i>{this.state.errMsg}</Alert> : null }
          </Col>
        </Container>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps (dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    userActions: bindActionCreators(sessionActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)

export { Login }



// WEBPACK FOOTER //
// ./src/components/Login.js